import { useTranslations } from 'next-intl';
import {
  ContentLayout,
  SeaPageContent,
} from '@silvertours/common-landingpages-view';
import {
  BenefitsLegacy,
  ContentArticle,
  MarketingSlider,
  StageLegacy,
} from '@silvertours/front-features';

import { Body } from '../body';

const SeaContent = ({
  content: {
    article,
    globalRating,
    introduction,
    links,
    stage,
    textContent: { primaryHeadline },
  },
  sliderCards,
  ...commonProps
}: ContentLayout<SeaPageContent>) => {
  const t = useTranslations('features');
  const translations = t.raw('article' as any);

  return (
    <Body
      variant={{ kind: 'sea' }}
      bodyTop={
        <StageLegacy.Stage
          content={stage.content}
          headline={primaryHeadline}
          variant={{ kind: 'sea' }}
        />
      }
      searchData={stage?.content?.search}
      content={({ containerModule }) => [
        containerModule(
          'usp',
          <BenefitsLegacy.Usp rating={globalRating.content} />,
        ),
        containerModule(
          'introduction-content',
          <ContentArticle
            modules={introduction?.segments ?? []}
            translations={translations}
          />,
          !!introduction?.segments,
        ),
        containerModule(
          'article',
          <ContentArticle
            modules={article.segments}
            translations={translations}
          />,
        ),
        containerModule(
          'marketingSlider',
          <MarketingSlider.MarketingSlider
            isModernStage
            sliderCards={sliderCards?.content?.sliderCards}
          />,
          !!sliderCards?.content?.sliderCards?.length,
        ),
        containerModule(
          'linkLists',
          <ContentArticle
            modules={links.content ?? []}
            translations={translations}
          />,
          !!(links.content ?? []).length,
        ),
      ]}
      {...commonProps}
    />
  );
};

export { SeaContent };
